import _slicedToArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _classPrivateFieldInitSpec from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldGet from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
// Copyright 2017-2022 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { Option, Struct } from '@polkadot/types-codec';
import { objectProperty, objectSpread, u8aToHex } from '@polkadot/util';
var knownTypes = {
  address: 'Address',
  blockHash: 'Hash',
  blockNumber: 'BlockNumber',
  era: 'ExtrinsicEra',
  genesisHash: 'Hash',
  method: 'Call',
  nonce: 'Compact<Index>',
  runtimeVersion: 'RuntimeVersion',
  signedExtensions: 'Vec<Text>',
  tip: 'Compact<Balance>',
  version: 'u8'
};
/**
 * @name GenericSignerPayload
 * @description
 * A generic signer payload that can be used for serialization between API and signer
 */

var _extraTypes = /*#__PURE__*/new WeakMap();

export var GenericSignerPayload = /*#__PURE__*/function (_Struct) {
  _inherits(GenericSignerPayload, _Struct);

  var _super = _createSuper(GenericSignerPayload);

  function GenericSignerPayload(registry, value) {
    var _this;

    _classCallCheck(this, GenericSignerPayload);

    var extensionTypes = objectSpread({}, registry.getSignedExtensionTypes(), registry.getSignedExtensionExtra());
    _this = _super.call(this, registry, objectSpread({}, extensionTypes, knownTypes), value);

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _extraTypes, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldSet(_assertThisInitialized(_this), _extraTypes, {});

    var getter = function getter(key) {
      return _this.get(key);
    }; // add all extras that are not in the base types


    for (var _i = 0, _Object$entries = Object.entries(extensionTypes); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          type = _Object$entries$_i[1];

      if (!knownTypes[key]) {
        _classPrivateFieldGet(_assertThisInitialized(_this), _extraTypes)[key] = type;
      }

      objectProperty(_assertThisInitialized(_this), key, getter);
    }

    return _this;
  }

  _createClass(GenericSignerPayload, [{
    key: "address",
    get: function get() {
      return this.getT('address');
    }
  }, {
    key: "blockHash",
    get: function get() {
      return this.getT('blockHash');
    }
  }, {
    key: "blockNumber",
    get: function get() {
      return this.getT('blockNumber');
    }
  }, {
    key: "era",
    get: function get() {
      return this.getT('era');
    }
  }, {
    key: "genesisHash",
    get: function get() {
      return this.getT('genesisHash');
    }
  }, {
    key: "method",
    get: function get() {
      return this.getT('method');
    }
  }, {
    key: "nonce",
    get: function get() {
      return this.getT('nonce');
    }
  }, {
    key: "runtimeVersion",
    get: function get() {
      return this.getT('runtimeVersion');
    }
  }, {
    key: "signedExtensions",
    get: function get() {
      return this.getT('signedExtensions');
    }
  }, {
    key: "tip",
    get: function get() {
      return this.getT('tip');
    }
  }, {
    key: "version",
    get: function get() {
      return this.getT('version');
    }
    /**
     * @description Creates an representation of the structure as an ISignerPayload JSON
     */

  }, {
    key: "toPayload",
    value: function toPayload() {
      var result = {};
      var keys = Object.keys(_classPrivateFieldGet(this, _extraTypes)); // add any explicit overrides we may have

      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var value = this.get(key);
        var isOption = value instanceof Option; // Don't include Option.isNone

        if (!isOption || value.isSome) {
          result[key] = value.toHex();
        }
      }

      return objectSpread(result, {
        // the known defaults as managed explicitly and has different
        // formatting in cases, e.g. we mostly expose a hex format here
        address: this.address.toString(),
        blockHash: this.blockHash.toHex(),
        blockNumber: this.blockNumber.toHex(),
        era: this.era.toHex(),
        genesisHash: this.genesisHash.toHex(),
        method: this.method.toHex(),
        nonce: this.nonce.toHex(),
        signedExtensions: this.signedExtensions.map(function (e) {
          return e.toString();
        }),
        specVersion: this.runtimeVersion.specVersion.toHex(),
        tip: this.tip.toHex(),
        transactionVersion: this.runtimeVersion.transactionVersion.toHex(),
        version: this.version.toNumber()
      });
    }
    /**
     * @description Creates a representation of the payload in raw Exrinsic form
     */

  }, {
    key: "toRaw",
    value: function toRaw() {
      var payload = this.toPayload();
      var data = u8aToHex(this.registry.createTypeUnsafe('ExtrinsicPayload', [payload, {
        version: payload.version
      }]) // NOTE Explicitly pass the bare flag so the method is encoded un-prefixed (non-decodable, for signing only)
      .toU8a({
        method: true
      }));
      return {
        address: payload.address,
        data: data,
        type: 'payload'
      };
    }
  }]);

  return GenericSignerPayload;
}(Struct);